export var CmpStatus;
(function (CmpStatus) {
    CmpStatus["STUB"] = "stub";
    CmpStatus["LOADING"] = "loading";
    CmpStatus["LOADED"] = "loaded";
    CmpStatus["ERROR"] = "error";
})(CmpStatus || (CmpStatus = {}));
